import dayjs from "dayjs";
import { Button } from "../ui/button";
import { Video } from "lucide-react";
import Box from "../ui/Box";
import "dayjs/locale/fr";
dayjs.locale("fr");

interface Props {
  titre: string;
  date: string;
  intervenants: string | null;
  replayUrl: string | null;
  liveUrl: string | null;
  description: string | null;
  heureDebut: string | null;
  heureOuvertureAcces: string | null;
}

export default function WebinaireItem({
  titre,
  intervenants,
  date,
  replayUrl,
  liveUrl,
  description,
  heureDebut,
  heureOuvertureAcces,
}: Props) {
  const isPast = dayjs(date).endOf("day").isBefore(dayjs());
  const humanReadableDate = dayjs(date).format("DD MMMM YYYY");

  return (
    <Box>
      <h2 className='text-md font-bold mb-2'>
        <em className='text-purple-800'>{humanReadableDate}</em> - {titre}
      </h2>
      {intervenants && <div className='text-gray-400 text-sm mb-2'>Intervenant(s) : {intervenants}</div>}
      {description && <div className='text-gray-500 text-sm mb-3'>{description}</div>}
      {heureOuvertureAcces && !isPast && (
        <div className='text-gray-500 text-sm mb-0'>
          Heure d'ouverture de l'accès à la visio-conférence : {heureOuvertureAcces}
        </div>
      )}
      {heureDebut && !isPast && <div className='text-gray-500 text-sm mb-1'>Heure de début : {heureDebut}</div>}

      {isPast ? (
        replayUrl ? (
          <a href={replayUrl} target='_blank' rel='noopener noreferrer'>
            <Button className='mt-2' variant={"secondary"} icon={<Video className='w-5 h-5' />}>
              Regarder le replay
            </Button>
          </a>
        ) : (
          <div className='text-gray-400 italic text-xs'>Le replay sera bientôt disponible</div>
        )
      ) : liveUrl ? (
        <a href={liveUrl} target='_blank' rel='noopener noreferrer'>
          <Button
            icon={<Video className='w-5 h-5' />}
            onClick={() => window.open(liveUrl, "_blank")}
            className='flex flex-row gap-2 mt-2'
          >
            Voir en direct
          </Button>
        </a>
      ) : (
        <div className='text-gray-400 text-xs italic'>
          Le lien du live sera disponible et envoyé par email 7j avant le webinaire
        </div>
      )}
    </Box>
  );
}
